const eventHub = {
  install: function (Vue, options) {
    const main = new Vue()
    window.addEventListener('popstate', function (e) {
      main.$emit('popstate')
    })
    Vue.prototype.$eventHub = main
  }
}
export default eventHub
